export const UserModuleConsts = {
    THANKU_PAGE_TITLE: 'World of Sweets - Thank You',
    FORGOT_PASSWORD_PAGE_TITLE: 'World of Sweets - Forgot Password',
    SIGNIN_PAGE_TITLE:'World of Sweets - Login',
    PHONE_NUMBER_NUMERIC: /^(?=.*[0-9])[- +()0-9]+$/,
    POST_CODE:/^[a-z A-Z0-9]+$/,
    NUMERIC:/^[0-9]*$/,
    ALPHA_NUMERIC: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,14}$/,
    default_redirection_heading:'You are Logged in as different User',
    default_redirection_message:'To proceed further,you need to logout of the current credentials'

}